import { ENDPOINTS } from 'utils/endpoints';
import { APIResponseModal } from 'utils/modals';
import { GET_API_CALL, PATCH_API_CALL } from 'utils/services';
import SHOW_TOAST from 'utils/showToast';

export type BusinessDetail = {
    _id?: string;
    businessContact: string;
    businessEmail: string;
};

/** GET /api/v1/shinology/business-detail/ */
export const getBusinessDetail = (callback: (data: BusinessDetail | null) => void) => {
    GET_API_CALL(ENDPOINTS.BUSINESS_DETAIL.DETAIL, '', (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
            callback({
                _id: response.data._id,
                businessContact: `${response.data.businessContact || ''}`.trim(),
                businessEmail: `${response.data.businessEmail || ''}`.trim(),
            });
            return;
        }
        callback(null);
    });
};

/** PUT /api/v1/shinology/business-detail/ */
export const updateBusinessDetail = (
    payload: Pick<BusinessDetail, 'businessContact' | 'businessEmail'>,
    callback: (data: BusinessDetail | null) => void
) => {
    PATCH_API_CALL(ENDPOINTS.BUSINESS_DETAIL.DETAIL, payload, (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
            SHOW_TOAST(response.data?.message || 'Business detail updated successfully!', 'success');
            callback({
                _id: response.data._id,
                businessContact: `${response.data.businessContact || payload.businessContact}`.trim(),
                businessEmail: `${response.data.businessEmail || payload.businessEmail}`.trim(),
            });
            return;
        }
        callback(null);
    });
};
